import { useQuery } from '@tanstack/react-query';
import queryKeys from '../keys/queryKeys';
import { addLayers, deleteLayer, getCenterLayers, getEastLayers, getLayerDetail, getLayers, patchPublishLayer } from '../service/layers';
import useMutateHook from '../../useMutateHook';
import { layerType } from '../_interface';

export const useLayers = ({ layerType }: { layerType: layerType }) => {
  return useQuery({
    queryKey: [queryKeys.layersKeys.all({ layerType })],
    queryFn: () => getLayers({ layerType }),
  });
};

export const useAddLayer = () => {
  return useMutateHook({
    invalidQuery: [[queryKeys.layersKeys.all({})]],
    fetchApi: ({ srid, layerType, file, isOverwrite }) => addLayers({ srid, layerType, file, isOverwrite }),
  });
};

export const useLayerDetail = ({ layerId }) => {
  return useQuery({
    queryKey: [queryKeys.layersKeys.detail({ layerId })],
    queryFn: () => getLayerDetail({ layerId }),
    enabled: !!layerId,
  });
};

export const useEastLayer = ({ zoom, bbox, layerId, isShowPoints }) => {
  return useQuery({
    queryKey: [queryKeys.layersKeys.east(layerId), zoom, bbox],
    queryFn: () => getEastLayers(layerId, bbox),
    enabled: zoom > 16.5 && isShowPoints && !!layerId,
  });
};

export const useCenterLayer = ({ zoom, bbox, layerId, isShowPoints }) => {
  return useQuery({
    queryKey: [queryKeys.layersKeys.center(layerId), zoom, bbox],
    queryFn: () => getCenterLayers(layerId, bbox),
    enabled: zoom > 16.5 && isShowPoints && !!layerId,
  });
};

export const useDeleteLayer = () => {
  return useMutateHook({
    invalidQuery: [[queryKeys.layersKeys.all({})]],
    fetchApi: ({ layerId }) => deleteLayer(layerId),
  });
};

export const usePatchPublish = () => {
  return useMutateHook({
    invalidQuery: [[queryKeys.layersKeys.center({})], [queryKeys.layersKeys.east({})], [queryKeys.layersKeys.all({})]],
    fetchApi: ({ layerId }) => patchPublishLayer(layerId),
  });
};
